import axios from "axios";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { backendServerBaseURL } from "../../utils/backendServerBaseURL";

import { Form, FormikProvider } from "formik";
import { useContext } from "react";
import { ThemeContext } from "../../App";
import { Helmet } from "react-helmet-async";

export default function TwoStepVerification() {
  const params = useParams();
  const twoFactorToken = params.twoFactorToken;
  const navigate = useNavigate();
  const themeContextValue = useContext(ThemeContext);

  const RegisterSchema = Yup.object().shape({
    totp: Yup.number("Enter valid OTP").required("OTP is required"),
  });

  const formik = useFormik({
    initialValues: {
      totp: "",
    },
    validationSchema: RegisterSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      setSubmitting(false);

      await axios
        .post(`${backendServerBaseURL}/auth/mfa/verify`, {
          twoFactorToken: twoFactorToken,
          totp: values.totp,
        })
        .then((response) => {
          localStorage.setItem("selectedMenu", "dashboard");
          if (
            response.status === 200 &&
            response.data.message === "Logged in Successfully"
          ) {
            localStorage.setItem(
              "accessToken",
              response.data.payload.accessToken
            );
            localStorage.setItem(
              "user",
              JSON.stringify(response.data.payload.user)
            );

            navigate("/dashboard");
          }
        })
        .catch((error) => {
          try {
            console.log(error);
            if (error.response.status === 400) {
              setErrors({ afterSubmit: error.response.data.message });
            }
          } catch (e) {
            console.log(e);
          }
        });
    },
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  return (
    <>
      <main id="content" role="main" className="main">
        <div
          className="position-fixed top-0 end-0 start-0 bg-img-start"
          style={{
            height: "32rem",
            backgroundImage: "url(/static/svg/components/card-6.svg)",
          }}
        >
          <div className="shape shape-bottom zi-1">
            <svg
              preserveAspectRatio="none"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 1921 273"
            >
              <polygon fill="#fff" points="0,273 1921,273 1921,0 " />
            </svg>
          </div>
        </div>
        {/* Content */}
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
            <div className="container py-5 py-sm-7">
              <a className="d-flex justify-content-center mb-5" href="/">
                <img
                  className="zi-2"
                  src="/logo.svg"
                  alt="Image Description"
                  style={{ width: "8rem" }}
                />
              </a>
              <div className="mx-auto" style={{ maxWidth: "30rem" }}>
                {/* Card */}
                <div className="card card-lg mb-5">
                  <div className="card-body text-center">
                    {/* <div className="mb-4">
                      <img
                        className="avatar avatar-xxl avatar-4x3"
                        src={
                          themeContextValue.selectedTheme === "dark"
                            ? "/static/svg/illustrations-light/oc-unlock.svg"
                            : "/static/svg/illustrations/oc-unlock.svg"
                        }
                        alt="Image Description"
                        data-hs-theme-appearance="default"
                      />
                    </div> */}
                    <div className="mb-5">
                      <h1 className="display-5">2-step Verification</h1>
                      <p className="mb-0">
                        Enter OTP generated by Google Authenticator or Authy app
                        on your smartphone
                      </p>
                      <p>Enter the code below.</p>
                    </div>
                    <div className="row gx-2 gx-sm-3">
                      {/* ToTP */}
                      <div className="row mb-4">
                        <div className="">
                          <input
                            type="number"
                            {...getFieldProps("totp")}
                            className="form-control"
                            placeholder="OTP"
                          />
                          <span
                            className="invalid-feedback"
                            style={{
                              display: Boolean(touched.totp && errors.totp)
                                ? "block"
                                : "none",
                            }}
                          >
                            {errors.totp}
                            {""}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Errors from server */}
                    {formik.errors.afterSubmit && (
                      <div className="alert alert-danger" role="alert">
                        {formik.errors.afterSubmit}
                      </div>
                    )}

                    <div className="d-grid mb-3">
                      <button type="submit" className="btn btn-primary ">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
                {/* End Card */}
              </div>
            </div>
          </Form>
        </FormikProvider>
        {/* End Content */}
      </main>
    </>
  );
}
